import { exportToExcel } from "utils/exportToExcel";

export const downloadShipmentTemplate = () => {
  exportToExcel(
    [
      {
        Marketplace: "",
        "Ship Method": "",
        "PO Number": "",
        "Ship Via": "",
        "Customer Name": "",
        Phone: "",
        "Line 1": "",
        "Line 2": "",
        City: "",
        State: "",
        Country: "",
        "Zip Code": "",
        SKU: "",
        Quantity: "",
        "Ref 1": "",
        "Ref 2": "",
        "Customer Order Number": "",
        "Customer Part Number": "",
        "Price": "",
      },
    ],
    "shipment_import_template",
  );
};
